/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.consumers
 */
UserApiConsumerService.$inject = [
    'USER_API_BASE_URL',
    'WITH_CREDENTIALS',
    'ApiConsumerService',
];
function UserApiConsumerService(
    USER_API_BASE_URL,
    WITH_CREDENTIALS,
    ApiConsumerService
) {
    return {
        get: get,
        post: post,
        put: put,
        delete: delete_request,
        request: request,
        getFullUrl: getFullUrl
    };

    /**
     * Makes a request (of the given type inside requestData) to the given url of the user api with the given parameters
     * It works as a substitute for $http({'method': 'post', 'url': url, ...}) in the consumer level
     * 
     * @param {Object} requestData Configuration object for $http
     * @param {Boolean} [withCredentials=true]
     * @return {Promise}
     */
    function request(requestData, withCredentials=true) {
        requestData.withCredentials = withCredentials;
        return ApiConsumerService.request(requestData, USER_API_BASE_URL);
    }

    /**
     * Makes a get request to the given url of the user api with the given parameters
     *
     * @param {String} url
     * @param {Object} [config]
     * @return {Promise}
     */
    function get(url, config) {
        config = config || WITH_CREDENTIALS;
        return ApiConsumerService.get(url, config, USER_API_BASE_URL);
    }

    /**
     * Makes a post request to the given url of the user api with the given data
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} [config]
     * @return {Promise}
     */
    function post(url, data, config) {
        config = config || WITH_CREDENTIALS;
        return ApiConsumerService.post(url, data, USER_API_BASE_URL, config);
    }

    /**
     * Makes a put request to the given url of the user api with the given data
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} [config]
     * @return {Promise}
     */
    function put(url, data, config) {
        config = config || WITH_CREDENTIALS;
        return ApiConsumerService.put(url, data, USER_API_BASE_URL, config);
    }

    /**
     * Makes a delete request to the given url of the user api with the given data
     *
     * @param {String} url
     * @param {Object} [config]
     * @return {Promise}
     */
    function delete_request(url, config) {
        config = config || WITH_CREDENTIALS;
        return ApiConsumerService.delete(url, USER_API_BASE_URL, config);
    }

    /**
     * Gets the full url for the user api based on the given relative url
     *
     * @param {string} url
     * @returns {string}
     */
    function getFullUrl(url) {
        return ApiConsumerService.getFullUrl(USER_API_BASE_URL, url);
    }
}

module.exports = UserApiConsumerService;